import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Grid, Typography, FormControl, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import DrangAndDrop from './DragAndDrop';

const useStyles = makeStyles({
  input: {
    width: '100%'
  },
  formControl: {
    width: '100%',
    marginTop: 16
  }
});

const UploadForm = (props) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    handleCancel,
    setContent,
    accept,
    title,
    actionButtonLabel = t('bundleUploadView:title')
  } = props;

  const classes = useStyles();
  return (
    <form onSubmit={handleSubmit}>
      <Grid container>
        <Typography component='h3'>
          {title}
        </Typography>
        <DrangAndDrop
          setContent={setContent}
          accept={accept}
        />
        <FormControl className={classes.formControl}>
          <Button variant='outlined' color='primary' onClick={handleCancel} style={{ marginBottom: 20 }}>
            {t('docUpload:cancel')}
          </Button>
          <Button variant='contained' color='primary' type='submit'>
            {actionButtonLabel}
          </Button>
        </FormControl>
      </Grid>
    </form>
  );
};

UploadForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  setContent: PropTypes.func.isRequired,
  accept: PropTypes.array,
  title: PropTypes.string.isRequired,
  actionButtonLabel: PropTypes.string
};

export default UploadForm;
